import { Ecr } from "api/memberPortal/ecr/ecr.types";
import {
  EcrNoteResponseType,
  EcrNoteType,
} from "api/memberPortal/ecr/ecrOptions.types";
import { EcrNote, EcrNoteStub } from "api/memberPortal/ecr/notes/ecrNotes.types";
import { z } from "zod";

interface AlertProps {
  message: string;
  variant: string;
}

type setAlert = ({ message, variant }: AlertProps) => void;

export interface EcrNoteFormProps {
  comment: Ecr;
  handleClose: () => void;
  note?: EcrNote | null;
  noteType: EcrNoteType;
  replyTo?: EcrNote | EcrNoteStub | null;
  responseType: EcrNoteResponseType;
  setAlert: setAlert;
  show: boolean;
}

interface BaseNoteFormValues {
  gist: string;
  note1: string;
}

// for note forms that check Is Private and visibility to Labs/Validators
export interface LabValidatorPrivateNoteFormValues extends BaseNoteFormValues {
  visible_to_labs: boolean;
  visible_to_validators: boolean;
  private: boolean;
}

const BaseNoteFormSchema = z.object({
  gist: z.string(),
  note1: z.string().min(1, "Note is required"),
});

export const LabValidatorPrivateNoteFormSchema = BaseNoteFormSchema.extend({
  private: z.boolean(),
  visible_to_labs: z.boolean(),
  visible_to_validators: z.boolean(),
});
